import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'getEmailTemplateSkeletonQueryKey';

export const useGetEmailTemplateSkeletonQuery = (emailTemplateId?: string) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, emailTemplateId],
    emailTemplateId
      ? () => api.get(API_URL.EXTERNAL_TEMPLATES_HTML_PREVIEW_BY_ID(emailTemplateId))
      : () => null,
    {
      cacheTime: 0,
    }
  );

  return {
    data: data?.data,
    isLoading,
  };
};
